import React, { useEffect, useState } from 'react';
import { Button, Input, Message, Table } from 'react-frontier2';
import { Location } from '@arema/components/Classes';
import { bindFormChange } from '@arema/components/Util';

interface Props{
	location: Location,
	onChange?: (value: any)=>void,
	allowEdit?: (keyof Location)[],
	onButtonClick: ()=>void,
	style?: React.CSSProperties,
	last?: boolean,
	top?: boolean,
}

var LocationView = (props: Props)=>{
	var [editingLocation, setEditingLocation] = useState(null);
	var location_keys : { [x in keyof Location]: string } = {
		city: 'Ciudad',
		country: 'País',
		exterior_number: 'Número',
		interior_number: 'Número interior',
		name: 'Nombre',
		neighborhood: 'Colonia',
		state: 'Estado',
		street: 'Calle',
		zipcode: 'Código postal',
	}

	if(!props.location) return <Message text="La ubicación no es válida" />

	var onEdit = ()=>{
		setEditingLocation(props.location);
	}

	var onSave = ()=>{
		props.onChange(editingLocation);
		setEditingLocation(null);
	}

	var location = (editingLocation || props.location);
	var rows = [];
	for(var i in location){
		if(!(location_keys as any)[i]) continue;
		rows.push({
			key: i,
			label: (location_keys as any)[i],
			value: (location as any)[i],
		});
	}

	var allowEdit = props.allowEdit || ['interior_number', 'exterior_number'];
	var onEditingChange = bindFormChange(editingLocation, v=>{
		props.onChange(v);
		setEditingLocation(v);
	});

	return <Table fitted details style={props.style} last={props.last} top={props.top}>
		<Table.Head title='Ubicación' titleRight={(
			editingLocation ? (
				<Button color="green" text="Listo" size="tiny" iconName={'check'} onClick={onSave} />
			) : (
				<div>
					{!!props.onChange && (
						<Button text="Editar" size="tiny" iconName={'pen'} onClick={onEdit} style={{ marginRight: 5 }} />
					)}
					<Button color="black" text="Cambiar" size="tiny" iconName={'pen'} onClick={props.onButtonClick} />
				</div>
			)
		)} />
		<Table.Body>
			{rows.map((a,i)=>(
				(a.key==='interior_number' && !a.value && !editingLocation) ? (
					null
				) : (
					<Table.Row key={`loctbl-${i}`}>
						<Table.Cell>{a.label}</Table.Cell>
						<Table.Cell compact={!!editingLocation} style={!!editingLocation ? { padding: '0.5rem' } : null}>
							{editingLocation && (allowEdit.indexOf(a.key as any)!=-1) ? (
								<Input style={{ margin: 0 }} inputStyle={{ padding: 8 }} value={a.value} placeholder={a.label} onChange={onEditingChange(a.key)} />
							) : (
								a.value || <i style={{ color: 'brown' }}>Información faltante</i>
							)}
						</Table.Cell>
					</Table.Row>
				)
			))}
		</Table.Body>
	</Table>
}

export default LocationView;